/**
 * Created by 槟 on 2018/4/10.
 */
export const UPDATE_SEARCH_RENT_DATA = 'personSearchRent/UPDATE_SEARCH_RENT_DATA';
const initialState = {
    personSearchRentData:{
        personSearchRent:[]
    },
};
const personSearchRentDataReducer =  (personSearchRentData=0, action)=>{
    switch (action.type) {
        case UPDATE_SEARCH_RENT_DATA:
            return {
                ...personSearchRentData,
                [action.subType]:action.data
            }
        default:
            return personSearchRentData
    }
}
export default (state = initialState, action) => {
    return {
        personSearchRentData : personSearchRentDataReducer(state.personSearchRentData, action)
    };
}
export const dispatch_func = {
    update_personSearchRentData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_SEARCH_RENT_DATA,
                data:data,
                subType:type
            });
        }
    },
};


// WEBPACK FOOTER //
// ./src/modules/personSearchRent.js